<template>
  <div class="box1">
    <div class="content" v-if="haveList === true">
      <div class="item" v-for="(item,index) in dataList" :key="index">
        <span class="col"></span>
        <div class="item_title1">{{item.operateTypeValue}}</div>
        <div class="text_content">
          <p class="tip1">{{item.createTime}}</p>
          <div class="tip2" v-if="item.operateType==1045||item.operateType==1050||item.operateType==1011||item.operateType==1015||item.operateType==1140||item.operateType==1150">
            <span class="text_content_spa">处理时长: {{item.handleLong|timeStamp()}} 累计时长：{{item.handleAccumulativeLong|timeStamp()}}</span>
          </div>
          <div class="tip2">
            <!-- <span>处理单位：</span> -->
            <!-- <span class="text_content_spa">{{item.operate_org_name}}</span> -->
            <span class="text_content_spa">{{item.operateOrgName}}</span>
          </div>
          <div class="tip2">
            <!-- <span>处理人：</span> -->
            <!-- <span class="text_content_spa">{{item.operateOrgName}}</span> -->
            <span class="text_content_spa">{{item.operateUserName}}</span>
          </div>
          <div class="tip2" v-if="item.operateType===1060">
                  <!-- <div class="orige">{{item.operate_org_name}}</div> -->
                  <div class="score" v-for="(item1,index1) in item.evaluation" :key="index1"><i>{{item1.feedbackOrgName}} : </i>
                  <img src="../../../../assets/image/happy.png" v-if="item1.score===3"/><img src="../../../../assets/image/norCopy.png" v-if="item1.score===2"/>
                  <img src="../../../../assets/image/unhappy.png" v-if="item1.score===1"/>
                  <i v-if="item1.score===3">满意</i>
                  <i v-if="item1.score===2">基本满意</i>
                  <i v-if="item1.score===1">不满意</i>
                  </div>
                  <div class="remark">{{item.operateContent}}</div>
          </div>
          <div class="tip2" v-if="item.operateType!=1060">
            <!-- <span>处理内容：</span> -->
            <span class="text_content_spa">{{item.operateContent}}</span>
          </div>
          <div class="imgList">
            <img
              :src="i"
              alt
              v-for="(i,idx) in item.url"
              :key="idx"
              @click="showViewer(idx, $event,item.url)"
            />
          </div>
          <!-- <p class="about_text">尊敬的旅客，您好！由于夜间到港航班高峰,尊敬的旅客，您好！由于夜间到港航班高峰,
          尊敬的旅客，您好！由于夜间到港航班高峰尊敬的旅客，您好！由于夜间到港航班高峰</p>-->
        </div>
      </div>
    </div>
    <isNoInfo :isNolist='isNolist'></isNoInfo>
    <!-- <scroll-bottom></scroll-bottom> -->
  </div>
</template>
<script>
    import api from '../../../../service/modules/complaintApis';
    import isNoInfo from '../../../../components/isNoInfo';
    import scrollBottom from './scrollBottom'
    import util from '../../../../utils/common';
    export default {
        components: {
            isNoInfo,
            'scroll-bottom': scrollBottom
        },
        data () {
            return {
                dataList: [],
                item: util.getJsonLocal('item'), 
                isNolist: false,
                haveList: false
            };
        },
        created () {
            this.handList();
        },
        methods: {
            handList () {
                // 获取页面基础数据
                let parms = {
                    data:{
                      mainComplainNumber: this.item.mainComplainNumber,
                      type: 'timeAxis',
                      complainNumber: this.item.complainNumber,
                      timeAxisType: 'all'
                    }
                };
                api.worker.detailInfo(parms).then(res => {
                    if (res.ret === 0) {
                        if (res.data) {
                            if (res.data.timeAxis) {
                                if (res.data.timeAxis.length > 0) {
                                    this.dataList = res.data.timeAxis;
                                    console.log(this.dataList);

                                    this.isNolist = false
                                    this.haveList = true
                                } else {
                                    this.isNolist = true
                                }
                            } else {
                                this.isNolist = true
                            }
                        } else {
                            this.isNolist = true
                        }
                    }
                });
            },
            // 图片预览
            showViewer (index, event, imgList) {
                this.$ImagePreview({ images: imgList, startPosition: index, closeOnPopstate: true });
            }
        },
        filters:{
          timeStamp( second_time ){
              var time = parseInt(second_time) + "秒";
              if( parseInt(second_time )> 60){
              
                  var second = parseInt(second_time) % 60;
                  var min = parseInt(second_time / 60);
                  time = min + "分" + second + "秒";
                  
                  if( min > 60 ){
                      min = parseInt(second_time / 60) % 60;
                      var hour = parseInt( parseInt(second_time / 60) /60 );
                      time = hour + "小时" + min + "分" + second + "秒";
              
                      if( hour > 24 ){
                          hour = parseInt( parseInt(second_time / 60) /60 ) % 24;
                          var day = parseInt( parseInt( parseInt(second_time / 60) /60 ) / 24 );
                          time = day + "天" + hour + "小时" + min + "分" + second + "秒";
                      }
                  }
                  
              
              }
              
              return time;        
            },
        }

    };
</script>
<style lang="less" scoped>
.box1 {
  width: 100%;
  background-color: #fbfbfb;
  padding: 0 12px 12px 12px;
  position: relative;
  left: 0;
  top: 0;
  z-index: 2;
  .content {
    width: 100%;
    padding: 30px 10px 0 20px;
    box-sizing: border-box;
    background-color: #fff;

    .item {
      width: 100%;
      position: relative;
      font-size: 14px;
      border-left: 1px solid #efefef;

      .col {
        position: absolute;
        left: -7px;
        top: -6px;
        width: 12px;
        height: 12px;
        background-color: #fff;
        border-radius: 50%;
        border: 1px solid #36b374;
      }
      .item_title1 {
        width: 100%;
        position: absolute;
        left: 17px;
        top: -5px;
        color: #333;
        font-size: 14px;
        font-weight: 700;
      }
      .text_content {
        margin-left: 18px;
        padding-top: 22px;
        padding-bottom: 20px;
        .tip1 {
          font-size: 12px;
          color: #333;
        }
        .text_content_spa {
          line-height: 22px;
          overflow: hidden;
          white-space: pre-wrap; 
          word-break: break-all;
        }
        .tip2 {
          margin-top: 8px;
          span {
            font-size: 14px;
          }
          span:nth-child(1) {
            color: #9b9b9b;
          }
          span:nth-child(2) {
            color: #9b9b9b;
          }
          .score{
            margin-top:10px;
            i{
              display: inline-block;
              font-size:14px;
              color:#9b9b9b;
              vertical-align: middle;
            }
            img{
              display: inline-block;
              width:15px;
              height:15px;
              vertical-align: middle;
              margin-left:10px;
            }
          }
          .remark{
            margin-top:10px;
            font-size:14px;
            color:#9b9b9b;
          }
        }
        .imgList {
          overflow: hidden;
          img {
            margin-top: 10px;
            float: left;
            width: 70px;
            height: 70px;
            display: block;
            margin-right: 10px;
            border-radius: 3px;
          }
        }
        .about_text {
          font-size: 14px;
          color: #333333;
          line-height: 1.4em;
          margin-top: 12px;
        }
      }
    }
    .item:last-child {
      border: none;
    }
  }
  /deep/.main {
      .box1{
          margin-top: 100px;
      }
  }
}
</style>
